import axios from 'axios';
let API_URL = '';
export class UserAPI {

    constructor(baseURL) {
        API_URL = baseURL;
    }

    GetEmployeePrivateProfile() {
        const url = API_URL + '/API/Core/User/GetEmployeePrivateProfile';
        return axios.get(url)
            .then(response => response.data);
    }
    GetSpecifiedEmployeePrivateProfile(userID){
        const url = API_URL + '/API/Core/User/GetSpecifiedEmployeePrivateProfile';
        return axios.get(
            url,
            {
                params: {
                    userId:userID
                }
            })
            .then((response) => {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
    }


}